<template>
  <div>
    <b-toast id="toast-equis-nav-bar" variant="none" no-close-button toaster="b-toaster-top-center">
      <img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px"/>
      {{ message }}
    </b-toast>
    <b-toast
      id="toast-check-nav-bar"
      variant="none"
      no-close-button
      toaster="b-toaster-top-center"
    >
      <img
        src="@/assets/img/ico-check.png"
        style="margin-right: 10px; margin-top: -2px"
      />
      {{ message }}
    </b-toast>
    <b-navbar toggleable="lg" type="dark" fixed="top">
      <div class="no_desktop" style="flex:1">
        <div class="nav_mobile">
          <b-navbar-brand href="#">
            <img src="@/assets/img/logo.png" />
          </b-navbar-brand>
          <b-avatar class="ml-auto" variant="light" v-if="User"
            :src="User && User.photo ? User.photo : IMAGENES.PHOTO_TEACHER_DEFAULT"
          ></b-avatar>
        </div>
      </div>
      <div v-if="!is_teacher" class="content-select no_mb" v-bind:class="lang">
        <b-dropdown :text="lang == 'en' ? 'English' : 'Español'"  style="max-width:150px;"
          text-field="name"
          disabled-field="notEnabled"
          variant="link"
          no-caret
          :class="[lang]"
        >
          <b-dropdown-item v-if="lang=='en'" @click="handleChange(0)"> <img src="@/assets/img/language-1.png" alt=""> Español</b-dropdown-item>
          <b-dropdown-item v-if="lang=='es'" @click="handleChange(1)"> <img src="@/assets/img/language-2.png" alt=""> English</b-dropdown-item>
        </b-dropdown>
      </div> 
     
   

      <b-navbar-toggle target="nav-collapse">
        <!-- <icon name="burger-responsive" /> -->
        <div class="hamburger-lines">
          <span class="line line1"></span>
          <span class="line line2"></span>
          <span class="line line3"></span>
        </div>
      </b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-nav>
              <b-nav-item v-if="!is_teacher" id="planesPrices" to="/compra/0"><icon v-if="!isDesktop" name="label" />{{$t('navbar.subtitulo')}}</b-nav-item>
              <b-nav-item v-if="!is_teacher" id="faqs" to="/faqs"><icon v-if="!isDesktop" name="comment-question" />{{$t('navbar.faqs')}}</b-nav-item>
              <b-nav-item v-if="is_teacher" id="faqs" to="/teacher/faqs">{{$t('navbar.faqs')}}</b-nav-item>
              <b-nav-item-dropdown v-if="!is_teacher && User && $store.state.datosSidebar.flagPurchaseHistory && isDesktop" toggle-class="text-decoration-none" no-caret right class="arrowDropdown">
                <template #button-content>
                  <span>{{$t('navbar.historial')}}</span>
                  <icon name="arrow-bottom" />
                </template>
                <b-dropdown-item to="/student/historial-compras"><icon name="cart" /><p>{{$t('navbar.options.17')}}</p></b-dropdown-item>
                <b-dropdown-item  to="/student/historial-cursos"><icon name="course" /><p>{{$t('navbar.options.18')}}</p></b-dropdown-item>
              </b-nav-item-dropdown>
            </b-nav>
            <div class="content-icons p-0" v-if="User && (is_teacher || $store.state.datosSidebar.flagPurchaseHistory) && isDesktop" :class="false ? 'noneNotifications':'' " >
              <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret id="ddownNotification" class="arrowDropdown">
                <template #button-content >
                  <icon name="campaign" />
                  <div class="dot" v-show="datosNav && datosNav.nroNotifications != 0">{{datosNav.nroNotifications}}</div>
                </template>
                <div class="text-center" v-show="loadingNotifications">
                  <b-spinner variant="primary"></b-spinner>
                </div>
                <div v-if="notifications.length != 0 ">
                  <div class="scroll" id="scroll1" :class="validScroll ? 'mr-2' : '' ">
                    <b-dropdown-text v-show="false"  @click="scrollDropdownMethod(1)" :class="onScroolling ? 'oncursor':''">
                      <span>{{$t('navbar.options.1')}}</span>
                    </b-dropdown-text>
                    <b-dropdown-item  v-for="item in notifications" :key="item.id" :id="'notification'+item.id" @click="getInformationNotification(item)">
                      <div class="d-flex flex-column align-items-baseline">
                        <p :style="{fontWeight: item.flagNew ? '900' : '300'}" v-html="(lang == 'en' && !is_teacher) ? item.subjecT_EN : item.subject"></p>
                        <span>{{item.dateReadable}}</span>
                      </div>
                    </b-dropdown-item>
                  </div>
                  <div v-if="true" class="button-footer">
                    <b-link class="link" style="font-size:14px" @click="GetNotifications(notificationPage);"  >{{$t('reusables.load-more')}}</b-link>
                  </div>
                </div>
                <div v-else v-show="!loadingNotifications" class="text-center" style="margin-bottom: 11px;font-size: 13px;">
                  {{$t('navbar.noNotification')}}
                </div>
               
                <div class="scroll" id="scroll2" v-show="false">
                  <b-dropdown-text class="position-absolute" @click="scrollDropdownMethod(2)" :class="onScroolling ? 'oncursor':''">
                    <span>{{$t('navbar.options.2')}}</span>
                  </b-dropdown-text>
                  <b-dropdown-item>
                    <p>Action</p>
                    <span>9:50pm</span>
                  </b-dropdown-item>
                </div>
              </b-dropdown>
            </div>
            <div class="avatar-user no_mb" v-if="User">
              <div>
                <h6>{{User.strFullName}}</h6>
                <span class="profile">{{is_teacher ? 'Teacher' : $t('reusables.student')}}</span>
              </div>
              <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret right class="arrowDropdown">
                <template #button-content>
                  <b-avatar class="mr-2" variant="light"
                    :src="User.photo ? User.photo : IMAGENES.PHOTO_TEACHER_DEFAULT"
                     style="background:#B7B8BD;"
                  ></b-avatar>
                  <icon name="arrow-bottom" />
                </template>
                <b-dropdown-item @click="userStudent()" v-show="false"><p>{{$t('navbar.options.3')}}</p></b-dropdown-item>
                <b-dropdown-item @click="LoginTeacher()" v-show="false"><p>{{$t('navbar.options.4')}}</p></b-dropdown-item>
                <!-- OPCIONES DEL ESTUDIANTE -->
                <b-dropdown-item v-if="!is_teacher" to="/student/account/information"><icon name="user" /><p>{{$t('navbar.options.5')}}</p></b-dropdown-item>
                <b-dropdown-item v-if="!is_teacher" to="/setting"><icon name="world" /><p>{{$t('navbar.options.11')}}</p></b-dropdown-item>
                <!-- <b-dropdown-item to="/student/account/information" v-if="!is_teacher"><p>{{$t('navbar.options.17')}}</p></b-dropdown-item> -->
                <!-- <b-dropdown-item v-if="!is_teacher"><p>{{$t('navbar.options.6')}}</p></b-dropdown-item>
                <b-dropdown-item v-if="!is_teacher"><p>{{$t('navbar.options.7')}}</p></b-dropdown-item> -->
                <!-- <b-dropdown-item v-if="!is_teacher"><p>{{$t('navbar.options.8')}}</p></b-dropdown-item>
                <b-dropdown-item v-if="!is_teacher"><p>{{$t('navbar.options.9')}}</p></b-dropdown-item> -->
                <!-- OPCIONES DEL PROFESOR -->
                <b-dropdown-item to="/teacher/account" v-if="is_teacher"><icon name="user" /><p>{{$t('navbar.options.14')}}</p></b-dropdown-item>
                <b-dropdown-item to="/setting" v-if="is_teacher"><icon name="world" /><p>{{$t('navbar.options.11')}}</p></b-dropdown-item>
                <!-- <b-dropdown-item v-if="is_teacher"><p>{{$t('navbar.options.15')}}</p></b-dropdown-item> -->
                <!-- <b-dropdown-item v-if="is_teacher"><p>{{$t('navbar.options.16')}}</p></b-dropdown-item> -->
                <!-- CERRAR SESION -->
                <b-dropdown-item @click="cerrarSesion(objFirebase)"><icon name="close" /><p>{{$t('navbar.options.10')}}</p></b-dropdown-item>
              </b-dropdown>
            </div>
            <div v-if="!is_teacher" class="content-select no_desktop" v-bind:class="lang">
              <b-dropdown :text="lang == 'en' ? 'English' : 'Español'"
                text-field="name"
                disabled-field="notEnabled"
                variant="link"
                no-caret
                :class="[lang]"
              >
                <b-dropdown-item v-if="lang=='en'" @click="handleChange(0)"> <img src="@/assets/img/language-1.png" alt=""> Español</b-dropdown-item>
                <b-dropdown-item v-if="lang=='es'" @click="handleChange(1)"> <img src="@/assets/img/language-2.png" alt=""> English</b-dropdown-item>
              </b-dropdown>
            </div>
            <!-- <div class="content-icons p-0" v-if="User">
              <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret right>
                <template #button-content>
                  <span class="material-icons-outlined">settings</span>
                </template>
                <b-dropdown-item to="/setting">{{$t('navbar.options.11')}}</b-dropdown-item>
              </b-dropdown>
            </div> -->
            <template v-if="!User">
              <b-nav class="no_user">
                <b-nav-item to="/student/login">{{$t('navbar.options.13')}}</b-nav-item>
                <b-nav-item to="/student/register" class="btn_mobile">{{$t('navbar.options.12')}}</b-nav-item>
              </b-nav>
            </template>
            <template v-else-if="!isDesktop">
              <b-nav class="no_user">
                <b-nav-item @click="cerrarSesion(objFirebase)">{{$t('navbar.options.10')}}</b-nav-item>
              </b-nav>
            </template>

          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <ModalNotification  />
    <ModalScoreTeacher  ref="modalScore" @close-window-recommend='handleEvent()' />

    
    <viewScheduleNavs :showActions="showActions" ref="modalCalendarNav"  @update-schedule-class-request="handleRequestClass"   />
    <viewScheduleTeacherNav ref="modalCalendarTeacherNav" @update-schedule="handlClaseModalTeacher" />
   
    <b-modal
            id="modal-reject"
            centered
            hide-footer >
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()">
        <h5>{{titleReject}}</h5>
        <h5>{{$t('modals.modal-reject.title')}}</h5>
      </template>
      <p class="d-flex align-items-center">
        <span>{{bodyExplain}}</span>
      </p>   
      <p>
      <b-link  @click="$bvModal.hide('modal-reject'); $router.push({name:'horario'})" v-if="flagLink" >
        {{"Ir Horario"}}
      </b-link >
      </p>
    </b-modal>

    <b-modal id="modal-notification-2" centered hide-footer>
      <template #modal-header="{ close }">
        <img class="close" src="@/assets/img/close_red.png" @click="close()">
      </template>
        <div class="align-items-center" v-html="bodyChangeSubject"></div>
    </b-modal>
  </div>
</template>

<script>
import {mapState} from "vuex";
import AuthenticationMixin from '@/assets/js/authenticationMixin.js';
import { PERFILES, PAGINACIONES, IMAGENES, DEVICE} from '@/assets/js/appConstants'; 
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import ModalNotification from "@/components/modals/notification";
import ModalScoreTeacher from "@/components/modals/modal-score-teacher";
import * as Constants from "@/assets/js/appConstants";
import viewScheduleNavs from "@/components/modals/view-schedule-navs";
import viewScheduleTeacherNav from "@/components/modals/view-schedule-teacher-navs";
import {redirectHorario } from '@/assets/js/util.js';
import * as firebase from "firebase/app";
import "firebase/messaging";

export default {
  components: {
    ModalNotification,
    viewScheduleNavs,
    viewScheduleTeacherNav,
    ModalScoreTeacher
  },
  data: function() {
    const lang = localStorage.getItem('lang') || 'es';
  
    return {
      message: "Ya no esta activada esta notificación",
      showActions:false,
      onScroolling:false,
      API_URL: process.env.VUE_APP_API_URL,
      showLenguage:true,
      flagLink:false,
      usuario:'',
      lenguage:'',
      lang: lang,
      notifications:[],
      notificationTotal: 0,
      notificationPage: 1,
      notificacionesPerPage: PAGINACIONES.NOTIFICATIONS,
      loadingNotifications: false,
      bodyExplain : "",
      titleReject : "",
      validScroll: false,
      IMAGENES: IMAGENES,
      isDesktop: window.innerWidth > DEVICE.DESKTOP,
      objFirebase: firebase.default,
      bodyChangeSubject: ""
      /*options: [
        { item: 'es', name: 'Español' },
        { item: 'en', name: 'Inglés' },
      ]*/
    };
  },
  props: {
			datosNav: {
				type: Object
			}
	},
  mixins: [AuthenticationMixin],
  mounted(){
    this.validarSesion();
    this.cursorDropdownMethod();
    this.$root.$on('bv::dropdown::show', bvEvent => {
      if(bvEvent.componentId == "ddownNotification") {
        this.GetNotifications(this.notificationPage)
      }
    })
    this.$root.$on('bv::dropdown::hide', bvEvent => {
      if(bvEvent.componentId == "ddownNotification") {
     
        this.notifications = [];
        this.notificationPage = 1;
        this.notificationTotal =  0;
      }
    })
  },
  methods: {
    handleEvent(){
      this.message = this.$t('reusables.rating-successfully-recorded');
      this.$bvModal.show('toast-check-nav-bar');
    },
    handleRequestClass(){
     
      this.$root.$emit('updateViewRequestClass',true);
    },
    handlClaseModalTeacher(){
      this.$root.$emit('updateTeacherSchedule');
    },
    getInformationNotification(item){
       
          switch (item.typeNotification.value) {
              case Constants.TYPE_NOTIFICATIONS.EIA_01.VALUE:{
                let data = { id: item.associatedId} 
                this.$router.push({
                    name : 'evaluation-review',
                    params : data
                }).catch({}); 
                this.$root.$emit('updateReview',data);
            }
             break;
            case Constants.TYPE_NOTIFICATIONS.PGC_03a.VALUE:{
                let data = { id : 1 , groupId : item.body  , personStudentId : item.associatedId ,flagTab : true} 
                this.$router.push({name : 'teacher-student-evaluations-reports' , params : data } ).catch(()=>{})
                this.$root.$emit('updateTab',data);
            }
            
            break;

            case Constants.TYPE_NOTIFICATIONS.PGC_03b.VALUE:{
                 let data = { id : 1 , groupId :  item.body  , personStudentId : item.associatedId ,flagTab : false} 
                this.$router.push({name : 'teacher-student-evaluations-reports' , params :data } ).catch(()=>{})
                this.$root.$emit('updateTab',data);
            }
            
            break;

            case Constants.TYPE_NOTIFICATIONS.ECS_01.VALUE:{
              let data = {
                personTeacherId : item.associatedId,
                nameTeacher :item.body,
                photoTeacher: "",
                typeScore : 2,
                qualification: 0,
                commentary: "",
                id: 0,
                flagPublished: null
              };

              let params = {
                PersonStudentId :this.$store.state.user.personStudentId,
                PersonTeacherId : item.associatedId,
              };

              baseInstanceAxios
                .get(`${this.apiURL}/Resources/PersonsTeachers/GeTeacherCalificationByStudent`, {params})
                .then(resp => {
                  if(resp.data.entity){
                    data.photoTeacher = resp.data.entity.personsTeachers.person.photo;
                    data.qualification = resp.data.entity.qualification;
                    data.commentary = resp.data.entity.commentary;
                    data.id = resp.data.entity.id;
                    data.flagPublished = resp.data.entity.flagPublished;
                  }
                  this.$refs.modalScore.getShowModalScoreTeacher(data)
                });
            }
            
            break;
            case Constants.TYPE_NOTIFICATIONS.PSC_01.VALUE:
                this.$store.dispatch('updateClassRequestTab',false)
                /*
                  this.$router.push({name : 'teacher-class-request' , params : {
                  flagTab : false
                }}).catch(()=>{})
                */
                this.$router.push({name : 'teacher-class-request'}).catch(()=>{})
              break;
            case Constants.TYPE_NOTIFICATIONS.PSC_06.VALUE:
              this.$store.dispatch('updateClassRequestTab',true)
              this.$router.push({name : 'teacher-class-request'}).catch(()=>{})
            break;


            ///
            case Constants.TYPE_NOTIFICATIONS.PSC_02.VALUE:case Constants.TYPE_NOTIFICATIONS.PEH_01.VALUE:{
                let json = {
                  GroupScheduleProposalCustomId : item.associatedId,
                  TimeZoneName:this.$store.state.user.timeZoneName
                }
                baseInstanceAxios
                .post(
                      `${this.apiURL}/Resources/GroupsCoursesLessons/ScheduleTeacherCounterProposalDetailId`,
                        json).then(response => {
                            if(response.data.entity.groupScheduleCounterProposal){
                                const shedule = response.data.entity.groupScheduleCounterProposal;
                                let value = parseInt(shedule.typeSchedule.value);	
                            
                                let json = {
                                  flagPlanTest : shedule.flagPlanTest,
                                  id : shedule.id,
                                  flagAvailability : shedule.flagAvailability,
                                  personTeacherId : shedule.personTeacherId,
                                  groupScheduleProposalId : shedule.groupScheduleProposalId,
                                  typeScheduleName : shedule.typeSchedule.name,
                                  typeScheduleId : shedule.typeSchedule.id,
                                  typeScheduleValue : value ,
                                  requestDate : shedule.flagPlanTest ? shedule.requestDateStringShort : shedule.requestDateStringShort, //CHC: no he visto en la doc que se indique que no se muestre la fecha si es clase de prueba
                                  percentageSchedules : shedule.percentageSchedules,
                                  strPercentageSchedules : shedule.strPercentageSchedules,
                                  strSubjects : shedule.flagPlanTest ? this.$t('reusables.test-class')  :  shedule.listStrSubjects.replaceAll('[br]','\n'),
                                  groupsId : shedule.groupsId,
                                  flagTypeGroup: shedule.flagTypeGroup,
                  
                                  strFullNameList:shedule.strFullNameList,
                                  strFullName : shedule.flagTypeGroup? shedule.strFullNameList.replaceAll(',[br]','\n') :shedule.strFullNameList  ,
                                  strAge : shedule.flagTypeGroup? shedule.strAgeList.replaceAll(',[br]','\n') : shedule.strAgeList,
                                  level : shedule.flagTypeGroup? shedule.strAbbreviationList.replaceAll(',[br]','\n') : shedule.strAbbreviationList,
                          
                                  typeProposalId: shedule.typeProposal.id,
                                  photoStundet :shedule.personsPhoto,
                                  className :shedule.className,
                                  levelAbbreviationGroup :shedule.levelAbbreviationGroup,

                                }
                        
                              this.$bvModal.show('modal-schedule-navs'); 
                              this.showActions = true;
                              this.$refs.modalCalendarNav.getId(item.associatedId,json,response.data.entity.schedule.schedulesOptionsId);
      
                          }       
                });
                      
              }
              break;
              case Constants.TYPE_NOTIFICATIONS.PSC_05.VALUE:
                  this.$router.push({name : 'teacher/class'}).catch(()=>{})
              break;
        
            

              case Constants.TYPE_NOTIFICATIONS.ESC_01.VALUE: case Constants.TYPE_NOTIFICATIONS.ESC_03.VALUE:{
                if(item.flagActive){
                         let json = {
                  flagNotification : true,
                  groupScheduleProposalId : item.groupScheduleProposalId ,
                  groupScheduleCounterProposalId : item.associatedId,
                  personTeacherId: item.personTeacherId,
                  className:  item.className,
                  schedulesoptionsid: item.schedulesoptionsid,
                };
                this.$router.push({name : 'horario' ,
                params: {
                    student: json
                }
                }).catch(()=>{})
                }else{
                  this.$bvToast.show("toast-equis-nav-bar");
                }
              

              }
              
              break;
              case Constants.TYPE_NOTIFICATIONS.ESC_02.VALUE:
                this.flagLink = false;
                this.titleReject = item.subject
                this.bodyExplain = item.body
                this.$bvModal.show("modal-reject");
              break;
              case Constants.TYPE_NOTIFICATIONS.ESC_04.VALUE:
                this.flagLink = true;
                this.titleReject = "Reprogramar"
                this.bodyExplain = "Debes reprogramar tu clase de prueba."
                this.$bvModal.show("modal-reject");
              break;
              case Constants.TYPE_NOTIFICATIONS.EGC_01.VALUE:{
                this.showActions = false;
                this.$refs.modalCalendarNav.showModalEditStudent(true,item.associatedId,item.subject,false)
              }
              break;
              case Constants.TYPE_NOTIFICATIONS.PGC_01.VALUE:{
          
                this.showActions = false;
                this.$refs.modalCalendarNav.showModalEditStudent(true,item.associatedId,item.subject,true)
              }
              break;

              case Constants.TYPE_NOTIFICATIONS.PEH_02.VALUE:{
            
                let data = {
                  ScheduleId : item.associatedId
                }
                baseInstanceAxios
                  .get(`${this.apiURL}/resources/GroupScheduleCounterProposal/ListEditionScheduleByScheduleId`, {params: data})
                  .then(response => {
                    if(response.data.list.length>0){
                      let dataStudent = {
                        id: response.data.list[0].id,
                        requestDate:  response.data.list[0].requestDateString, 
                        beginningDate:  response.data.list[0].beginningDate, 
                        strFullName : response.data.list[0].flagGroup? response.data.list[0].codeGroup.replaceAll(',[br]','\n') :response.data.list[0].personsStudents.person.strFullName ,
                      }
                      window.scrollTo({ top: 0, behavior: "smooth" });
                          this.$nextTick(() => {        
                          document.documentElement.classList.add("modal-open"); 
                          document.querySelector(".content-main")?.classList.add("hide-background"); 
                          document.querySelector(".content-main")?.classList.add("push-down");
                       });    
                      this.$bvModal.show('modal-schedule-teacher-nav');
                      this.$refs.modalCalendarTeacherNav.getShowCalendar(dataStudent.id,dataStudent, true);
                    }       
                  });
              }
              break;
              case Constants.TYPE_NOTIFICATIONS.PHD_01.VALUE:case Constants.TYPE_NOTIFICATIONS.PHD_02.VALUE:case Constants.TYPE_NOTIFICATIONS.PFC_01.VALUE:case Constants.TYPE_NOTIFICATIONS.PFC_02.VALUE:{
                this.$router.push({name : 'teacher/schedule' }).catch(()=>{})
              }
              break;
              case Constants.TYPE_NOTIFICATIONS.EDP_01.VALUE:{
                this.$router.push({name : 'horario-calendario' , params : {id:'public'}}).catch(()=>{})
              }
              break;

              case Constants.TYPE_NOTIFICATIONS.EEG_02.VALUE:{
                  redirectHorario(this.$store.state.datosSidebar.typeScheduled, this, this.$store.state.is_representative);
              }
              break;
              
              case Constants.TYPE_NOTIFICATIONS.EEA_01a.VALUE:case Constants.TYPE_NOTIFICATIONS.EEA_01c.VALUE:case Constants.TYPE_NOTIFICATIONS.EEA_01d.VALUE:{
                this.$router.push({name : 'dashboard' }).catch(()=>{})
              }
              break;

              case Constants.TYPE_NOTIFICATIONS.EEA_01b.VALUE:{
                  this.$router.push({name : 'cursos' }).catch(()=>{})
              }
              break;

              case Constants.TYPE_NOTIFICATIONS.EEA_01e.VALUE:{
                  this.$router.push({name : 'evaluacion-nivel' }).catch(()=>{})
              }
              break;
              case Constants.TYPE_NOTIFICATIONS.PFI_01.VALUE:{
                this.$router.push({name : 'teacher-wallet' }).catch(()=>{})
              }
              break;
              case Constants.TYPE_NOTIFICATIONS.PGC_04.VALUE:{
                let [$title, ...$listChild] = item.body.split("|");
                this.bodyChangeSubject = `<h4>${$title}</h4>`;

                this.bodyChangeSubject += "<ul>";
                $listChild.forEach(x => { this.bodyChangeSubject += `<li>${x}</li>`; });
                this.bodyChangeSubject += "</ul>";
                
                this.$bvModal.show('modal-notification-2');
              }
              break;
            default:

              break;
          }
    },
    cursorDropdownMethod(){
    
      if(document.querySelector(".dropdown-menu.show") != null){
        if(document.querySelector(".dropdown-menu.show").scrollTop!=0) 
          this.onScroolling=true
      }
      
    },
    scrollDropdownMethod(value){ 
   
        if(document.querySelector(".dropdown-menu.show").scrollTop!=0){
          if(value==1){
          document.querySelector(".dropdown-menu.show").scrollTop = 0;
          }else{
            document.querySelector(".dropdown-menu.show").scrollTop= document.querySelector(".dropdown-menu.show").scrollHeight - document.querySelector("#scroll2").offsetHeight
          }
        }
    },
    showDropdown(){
     
      document.querySelector(".dropdown > button").addEventListener("click",()=>{
        this.openDropdown=false
        document.addEventListener("click",()=>{
          document.querySelector(".dropdown > .dropdown-menu").classList.remove("show")
          this.openDropdown=true})
      })
    },
    // tabIndexInicial(){
    //   if(this.$route.fullPath!='/compra'){
    //     debugger;
    //     this.$router.push('/compra')
    //     this.$store.commit("mutateTabIndex", 0);
    //   }else{
    //     this.$store.commit("mutateTabIndex", 0);
    //   }
    // },
    handleChange(value) {
      if(value==0){
        this.lang='es';
      }else this.lang='en'
      localStorage.setItem('lang', this.lang);
      if(this.$router.history.current.name =='materials'){
           this.$router.push('/materials');
      }
       window.location.reload();
    },
     
    LoginTeacher: function() {
			let user = {
          email:'jorge.prado@itsight.pe',
          password:'Welcome20',
          personsTypeId:PERFILES.PROFESOR
        };
      this.usuario='Teacher'
			baseInstanceAxios
				.post(this.API_URL + `/resources/Persons/ValidateLogin`, user)
				.then(response => {
					if (response.data != null) {
						if(response.data.entity != null){//LOGUEADO CON EXITO
           
              this.UserId = response.data.entity.id;
              this.User = {
                "id": response.data.entity.id,
                "firstName": response.data.entity.firstName,
                "lastName": response.data.entity.lastName,
                "strFullName": response.data.entity.strFullName,
                "email": response.data.entity.email,
                "photo": response.data.entity.photo,
                "personsTypeId":response.data.entity.personsTypeId,
                "personTeacherId": response.data.entity.personTeacherId,
                "isResponseReceived": response.data.entity.isResponseReceived,
              }
              this.$store.commit("mutateIsTeacher", true);
              this.$store.dispatch("updateFlagPostulant",response.data.entity.flagPostulant)
              this.$store.dispatch("updateFlagValidateCalifications",response.data.entity.flagValidateCalifications)
              this.$router.replace({name:"teacher/dashboard"})
						}else{
              this.messageLogin = response.data.message;
              this.$bvToast.show("toast-login-error");
            }
					}
				});
		},
    userStudent() {
      this.is_teacher = false; 
      this.usuario='Student'
    },
    GetNotifications : function(notificationPage){
    
      this.loadingNotifications = true;
      let json = {
					GroupsId: this.User.groupId != null ? this.User.groupId : 0,
					PersonId: this.User.id,
					PersonStudentId: this.User.personStudentId,
					Page: notificationPage,
					Size: this.notificacionesPerPage,
					TypeSearch: true,
          CultureInfo: this.lang == 'es' ? "es-PE" : "en-EN"
				};

				baseInstanceAxios
					.post(`${this.apiURL}/resources/dashboard/ListNotificationsByPerson`, json)
					.then((response) => {
           
						if(response.data != null){
							if(response.data.list != null ){
                this.notificationTotal = response.data.rows;

                if(notificationPage == 1){
                  this.notifications = response.data.list;
                  this.notificationPage = 2;
                  this.datosNav.nroNotifications = 0;
                }else{
                  this.notifications = this.notifications.concat(response.data.list);
                  this.notificationPage = this.notificationPage + 1;
                  
                }
							} 
							
						}
            this.loadingNotifications = false;
					});
    },
    UpdateNotifications(){
      let data = {
            PersonAssociatedId: this.User.personId,
            //ListIds: this.objInformation.subjects.map(subject => subject.id),
      }
      this.isLoading = true;

      baseInstanceAxios
				.post(this.API_URL + `/resources/Notifications/UpdateNotification_SetNotNew`, data)
        .then(() => {})
        .catch(function () {});
        },
  },
  computed: {
    User: {
      get() { 
        return this.$store.state.user;
      },
      set(value) {
        this.$store.commit('mutateUser', value);
      }
    },
    is_teacher: {
      get() {
        return this.$store.state.is_teacher;
      },
      set(value) {
        this.$store.commit("mutateIsTeacher", value);
      }
    },
    activeClass:function() {
      return this.tabIndexPills == 0 && this.$route.fullPath=='/compra' ? 'active' : ''
    },
    ...mapState(['tabIndexPills','flagPostulant'])
  }
};
</script>

<style></style>
